import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import styled from "styled-components";

import { CenterView } from "../../Component/style/common_style";

import Layout_user from "../../Component/UI/Layout_user";

import { fontStyles } from "../../Component/style/common_font";

import { usePublishedPolicy } from "./usePublishedPolicy";

import PublicPolicyContent from "./PublicPolicyContent";
import StorePolicyContent from "./StorePolicyContent";


const Topbar = styled(CenterView)`

  position: sticky;

  box-sizing: border-box;

  top: 0;

  z-index: 1;

  width: 100%;

  max-width: 500px;

  padding: 1rem;

  font-size: 20px;

  ${fontStyles.Bold}

  color: var(--user-text);
  background-color: var(--user-surface);
  overflow-wrap: anywhere;

`;

const Content = styled.div`

  padding: 1rem 1rem 4rem;

  font-size: 14px;

  white-space: pre-line;

  user-select: text;

`;



const Rule = ({ seller = false }: { seller?: boolean }) => {

  const { type } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [search] = useSearchParams();
  const storeSeqValue = Number(search.get('storeSeq'));
  const storeSeq = seller && Number.isSafeInteger(storeSeqValue) && storeSeqValue > 0 ? storeSeqValue : undefined;


  const policyKey = seller

    ? (type === "1" ? "seller_terms" : "seller_privacy")

    : (type === "1" ? "user_terms" : "user_privacy");

  const { state, retry } = usePublishedPolicy(policyKey, storeSeq);
  const ruletitle = state.status === "ready" ? state.policy.title : type === "1" ? "이용약관" : "개인정보 처리방침";



  return (

    <Layout_user background="white">

      {seller ? <Topbar className="end">{ruletitle}</Topbar> : <BuyerPolicyHeader>
        <button type="button" aria-label="뒤로가기" onClick={() => location.key === 'default' ? navigate('/', { replace: true }) : navigate(-1)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m14 5-7 7 7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </button><h1>{ruletitle}</h1>
      </BuyerPolicyHeader>}



      <Content>

        {storeSeq && state.status === "ready" && state.source === "store"
          ? <StorePolicyContent policy={state.policy} />
          : <PublicPolicyContent state={state} retry={retry} />}
      </Content>

    </Layout_user>

  );

};



export default Rule;

const BuyerPolicyHeader = styled.header`
  position:sticky;top:0;z-index:1;display:flex;align-items:center;justify-content:center;
  box-sizing:border-box;min-height:60px;padding:14px 56px;background:var(--user-surface);color:var(--user-text);border-bottom:1px solid var(--user-border);
  h1{margin:0;font:18px var(--font-Pretendard-SemiBold);line-height:1.5;text-align:center;overflow-wrap:anywhere;}
  button{position:absolute;left:8px;display:grid;place-items:center;width:44px;height:44px;padding:0;border:0;border-radius:8px;background:transparent;color:inherit;cursor:pointer;}
  button:focus-visible{outline:2px solid var(--user-accent);outline-offset:2px;}
`;

